import axios from "axios";

// All Magento API calls now go through the checkout-api backend proxy.
// This keeps the M2 API token server-side only.
const API_BASE = process.env.REACT_APP_CHECKOUT_API || '';
const BASE_URL = 'https://controllermodz.co.uk';

export const API_ENDPOINT = () => {
    return BASE_URL;
};

const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

export const M2_getOptions = async (sku) => {
    const cacheKey = `cm_options_${sku}`;
    try {
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
            const { data, ts } = JSON.parse(cached);
            if (Date.now() - ts < CACHE_TTL) {
                // Background refresh
                axios.get(`${API_BASE}/api/m2/options/${encodeURIComponent(sku)}`)
                    .then(res => {
                        localStorage.setItem(cacheKey, JSON.stringify({ data: res.data, ts: Date.now() }));
                    }).catch(() => {});
                return data;
            }
        }
    } catch (e) {}

    const res = await axios.get(`${API_BASE}/api/m2/options/${encodeURIComponent(sku)}`);
    try {
        localStorage.setItem(cacheKey, JSON.stringify({ data: res.data, ts: Date.now() }));
    } catch (e) {}
    return res.data;
};

export const M2_getProductByQuoteId = async (quoteId) => {
    const res = await axios.get(`${API_BASE}/api/m2/cart/${quoteId}/items`);
    return res.data;
};

export const M2_getQuoteId = async () => {
    const res = await axios.post(`${API_BASE}/api/m2/cart`);
    return res.data.cartId.toString();
};

export const M2_postAddProduct = async (cartItem) => {
    const res = await axios.post(`${API_BASE}/api/m2/cart/${cartItem.quoteId}/items`, { cartItem });
    return res.data;
};

export const M2_postUpdateProduct = async (cartItem, itemId) => {
    const res = await axios.put(`${API_BASE}/api/m2/cart/${cartItem.quoteId}/items/${itemId}`, { cartItem });
    return res.data;
};

export const M2_getEstimatedDeliveryDate = async (sku) => {
    const res = await axios.get(`${API_BASE}/api/m2/delivery/${sku}`);
    return res.data;
};

// { standard, rush, closure } from Wyomind EDD (Magento admin is the source of truth)
export const M2_getDeliveryEstimate = async (sku) => {
    const res = await axios.get(`${API_BASE}/api/m2/delivery-estimate/${sku}`);
    return res.data;
};
